import { formatRelative } from 'date-fns';
import { de as dateLocale } from 'date-fns/locale';

export function requestValidUntilOutput(jobOrDate) {
    const validUntil = jobOrDate instanceof Date ? jobOrDate : jobOrDate.dates
        .filter(date => date.technicianRequest)
        .map(date => date.technicianRequest)
        .sort((a, b) => {
            if (a.validUntil < b.validUntil) {
                return -1;
            } else if (a.validUntil > b.validUntil) {
                return 1;
            } else {
                return 0;
            }
        })[0].validUntil;

    return formatRelative(validUntil, new Date(), {
        locale: dateLocale,
        weekStartsOn: 1
    });
}

export function requestValidUntilOutputPerJob(jobOrDate) {
    const validUntil = jobOrDate.validUntil ? jobOrDate.validUntil : null;
    if (!validUntil) {
        return;
    }
    return formatRelative(validUntil, new Date(), {
        locale: dateLocale,
        weekStartsOn: 1
    });
}